import { render, staticRenderFns } from "./EstoqueForm.vue?vue&type=template&id=1b190c3c&scoped=true&"
import script from "./EstoqueForm.vue?vue&type=script&lang=js&"
export * from "./EstoqueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b190c3c",
  null
  
)

export default component.exports